import {
  ColumnDef,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  PaginationState,
  SortingState,
  Table,
  useReactTable,
  VisibilityState,
} from '@tanstack/react-table';
import { Dispatch, SetStateAction, useState } from 'react';
type UseTableProps<T> = {
  data: T[];
  columns: ColumnDef<T>[];
  rowCount: number;
  sorting: SortingState;
  setSorting: Dispatch<SetStateAction<SortingState>>;
  pagination: PaginationState;
  setPagination: Dispatch<SetStateAction<PaginationState>>;
  defaultColumnVisibilityState?: VisibilityState;
  manualPagination?: boolean;
  manualFiltering?: boolean;
  manualSorting?: boolean;
  extraData?: Record<string, unknown>;
};

export default function useDataTable<T>({
  columns,
  data,
  pagination,
  rowCount,
  sorting,
  setPagination,
  setSorting,
  manualSorting,
  manualFiltering,
  manualPagination,
  defaultColumnVisibilityState,
  extraData,
}: UseTableProps<T>): Table<T> {
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [rowSelection, setRowSelection] = useState({});

  const table = useReactTable({
    data,
    meta: { extraData },
    columns,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onRowSelectionChange: setRowSelection,
    rowCount,
    // enableMultiSort: true,
    enableSortingRemoval: true,
    manualPagination,
    manualFiltering,
    manualSorting,
    initialState: {
      columnVisibility: {
        ...defaultColumnVisibilityState,
      },
    },
    state: {
      pagination,
      sorting,
      columnFilters,
      rowSelection,
    },
    onPaginationChange: setPagination,
  });
  return table;
}
